import { render, staticRenderFns } from "./Perfis.vue?vue&type=template&id=35c6ae0b&scoped=true"
import script from "./Perfis.vue?vue&type=script&lang=ts"
export * from "./Perfis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c6ae0b",
  null
  
)

export default component.exports